import { render, staticRenderFns } from "./ThreeColumn.vue?vue&type=template&id=4abfa0de"
import script from "./ThreeColumn.vue?vue&type=script&lang=js"
export * from "./ThreeColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports